/**
 * To use this module, add the following data attribute to any element in your html:
 * data-js-module="private-sales-filter"
 */
export default class PrivateSalesFilter {
    constructor() {
        this.cityFilter = document.getElementById('private-sales-filter-city');
        this.init();
    }

    init() {
        if (this.cityFilter) {
            this.cityFilter.addEventListener(
                'change',
                this.handleFilterPrivateSalesByCity.bind(this),
            );
        }
    }

    handleFilterPrivateSalesByCity() {
        const selectedCity = this.cityFilter.options[this.cityFilter.selectedIndex].value;
        const sales = document.getElementsByClassName('private-sale');
        for (let i = 0; i < sales.length; i++) {
            const sale = sales[i];
            const city = sale.getAttribute('data-city');
            if (selectedCity === '' || selectedCity === 'all' || city === selectedCity) {
                sale.style.display = 'block';
            } else {
                sale.style.display = 'none';
            }
        }
    }
}
